import { coreApi } from '@cp/shared/api/core';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { ClientPhotoCreateRequest, ClientPhotoCreateResponse } from '@common/model/client/photo/request';
import { CoreClientApiTags, coreClientApiTagTypes } from '@cp/entities/client';
import { CoreClientPhotoApiTags, coreClientPhotoApiTags } from './tags';

const BASE_URL = '/client/photos';

export const coreClientPhotoApi = coreApi
  .enhanceEndpoints({ addTagTypes: [...coreClientApiTagTypes, ...coreClientPhotoApiTags] as const })
  .injectEndpoints({
    endpoints: (builder) => ({
      getClientPhotoList: builder.query<unknown, void>({
        query: () => ({
          url: BASE_URL,
        }),
        providesTags: [CoreClientPhotoApiTags.ClientPhotoList],
      }),

      createClientPhoto: builder.mutation<ClientPhotoCreateResponse, ClientPhotoCreateRequest>({
        query: ({ original, cropped }) => {
          const body = new FormData();
          body.append('original', original);
          body.append('cropped', cropped);

          return {
            url: `${BASE_URL}`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: () => [CoreClientApiTags.ClientProfile, CoreClientPhotoApiTags.ClientPhotoList],
      }),

      deleteClientPhoto: builder.mutation<void, { id: ApiServerEntityIDType }>({
        query: ({ id }) => ({
          url: `${BASE_URL}/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [CoreClientPhotoApiTags.ClientPhotoList],
      }),
    }),
  });
